// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';
import { findDOMNode } from 'react-dom';
import _, {get} from 'lodash';

import {adminViewState} from '../../adminViewState';
import * as syncActionCreators from '../../../../redux/actionCreators/sync';
import deepUnset from '../../../../lib/deepUnset';
import { connect } from 'react-redux';

import Step from './c_Step';

@connect(store => {
  return {
    viewOrder: get(store, 'labels.viewOrder', [])
  };
})
export default class Steps extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    staticData: PropTypes.object.isRequired,
    applicant: PropTypes.object.isRequired,
    assessments: PropTypes.object.isRequired,
    behavioralAnswers: PropTypes.object.isRequired,
    workObjectives: PropTypes.object.isRequired,
    workExperiences: PropTypes.object.isRequired,
    ratings: PropTypes.object.isRequired,
    skills: PropTypes.object.isRequired,
    licenses: PropTypes.object.isRequired,
    designations: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    updateApplicantStatus: PropTypes.func.isRequired,
    profileId: PropTypes.number,
    applicantGroupName: PropTypes.string,
    arrayIndex: PropTypes.number,
    style: PropTypes.object,
    onChangeStep: PropTypes.func.isRequired,
    toggleGuide: PropTypes.func,
    guideOpen: PropTypes.bool,
    route: PropTypes.object.isRequired,
    viewOrder: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
  }

  updateProgress(step, substep, doneValue) {
    this.updateTempState('profile', `viewState.progress.admin.application.${step}.${substep}.done`, null, doneValue);
  }

  // modify tempState properties
  updateTempState = (parent, prop, event, val, cb) => {  // getting params as array [parent, prop, event, val, cb]

    const newTempState = _.cloneDeep(this.props.tempState);
    const propPath = parent && !prop ? parent : !parent && prop ? prop : `${parent}${prop[0] === '[' ? '' : '.'}${prop}`;

    if(val === undefined) {
      // unsets parent objects if they are empty
      deepUnset(newTempState, propPath);
    } else {
      _.setWith(newTempState, propPath, val, Object);
    }
          this.props.dispatch(
            syncActionCreators.updateTempState(newTempState)
          );

    if(typeof cb === 'function') {
      cb();
    }
  }

  accordionDidMount = (container) => {
    this.frozenStep = false;
    if (container) {
      let that = this;
      container.addEventListener('scroll', () => {
        const containerRect = findDOMNode(container).getBoundingClientRect();
        const routeCategory = this.props.route.params.category;
        const activeStepIndex = _.findIndex(this.props.viewOrder, function(o){return o.key == routeCategory});
        const activeSubStepIndex = _.findIndex((this.props.viewOrder[activeStepIndex] || {}).subNav || [], x => x.key == this.props.route.params.subcategory);
        const stepRect = findDOMNode(this.refs['step' + activeSubStepIndex]).getBoundingClientRect();
        if (!that.frozenStep && (stepRect.top - containerRect.top) < 0) {
          findDOMNode(that.refs['step' + activeSubStepIndex]).className += ' frozen';
          that.frozenStep = true;
        }
        if (that.frozenStep && (stepRect.top - containerRect.top) >= 0) {
          let el = findDOMNode(that.refs['step' + activeSubStepIndex]);
          el.className = el.className.replace(' frozen', '');
          that.frozenStep = false;
        }
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.route.params.subcategory !== this.props.route.params.subcategory) {
      const currentStepName = _.get(this.props, 'route.params.subcategory', '');
      const expandedStep = _.find(this.refs, (step) => _.get(step, 'props.activeSubStep.key', '') === currentStepName);
      const stepId = _.get(expandedStep, 'props.activeSubStepIndex', '');

      if (stepId) {
        document.getElementById(`step${stepId}`).scrollIntoView();
      }
    }
  }

  render() {
    const {
      steps,
      ...otherStyles
    } =  this.props.style;

    const routeCategory = this.props.route.params.category;
    const activeStepIndex = _.findIndex(this.props.viewOrder, function(o){return o.key == routeCategory});

    const activeStep = (this.props.viewOrder[activeStepIndex] || {});
    const subSteps = (this.props.viewOrder[activeStepIndex] || {}).subNav || [];
    const viewState = _.get(_.merge({}, this.props.applicant.profile.viewState || {}, (this.props.tempState && this.props.tempState.profile) ? this.props.tempState.profile.viewState : {}), 'progress.admin.application', adminViewState);

    return  (
      <div className='steps-container clearfix' style={otherStyles}>
        <div className='steps' style={steps}>
          <div className='scroll-hide' ref={ this.accordionDidMount }>
            <ol className='profile-steps'>
              <div className='profile-accordion'>
              {
                subSteps.map((item, index) =>
                  <Step
                    key={index}
                    applicantGroupName={this.props.applicantGroupName}
                    arrayIndex={this.props.arrayIndex}
                    dispatch={this.props.dispatch}
                    staticData={this.props.staticData}
                    activeStep={activeStep}
                    activeSubStep={item}
                    activeSubStepIndex={index}
                    isLast={(index === subSteps.length - 1)}
                    applicant={this.props.applicant}
                    behavioralAnswers={this.props.behavioralAnswers}
                    workObjectives={this.props.workObjectives}
                    workExperiences={this.props.workExperiences}
                    ratings={this.props.ratings}
                    skills={this.props.skills}
                    licenses={this.props.licenses}
                    designations={this.props.designations}
                    tempState={this.props.tempState}
                    viewState={viewState}
                    updateProgress={this.updateProgress.bind(this, activeStep.key, item.key)}
                    updateTempState={this.updateTempState.bind(this)}
                    assessments={this.props.assessments}
                    toggleGuide={this.props.toggleGuide}
                    guideOpen={this.props.guideOpen}
                    style={{...steps}}
                    onChangeStep={this.props.onChangeStep}
                    route={this.props.route}
                    ref={`step${index}`}
                  />
                )
              }
              </div>
            </ol>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/c_Steps/index.js